// extracted by mini-css-extract-plugin
export var box = "_8i-1";
export var checked = "_8i-2";
export var descriptionSpacer = "_8i-9";
export var disabled = "_8i-3";
export var icon = "_8i-6";
export var input = "_8i-0";
export var labelSpacer = "_8i-8";
export var medium = "_8i-5";
export var small = "_8i-4";
export var text = "_8i-7";